<template lang="pug">
section
  s-page-title(:previous='true')
    template(slot='title')
      | Создание расписания осмотров
      br
      | на {{ title }}
    template(slot='extension')
      div(:class=`{
        'no-wrap': true,
        'align-content-start flex mt-3': $vuetify.breakpoint.mdAndDown
      }`)
        v-btn(
          @click='onTodayClick'
          :disabled='!isRunning'
          v-if='$vuetify.breakpoint.lgAndUp'
          class='mt-0 mr-3'
          color='accent'
          small flat
        ) Сегодня
        v-btn(
          @click='prevPeriod'
          :disabled='!isRunning'
          :icon='$vuetify.breakpoint.smAndDown'
          color='default'
          class='mt-0 ml-0'
          depressed small
        )
          v-icon(:left='!$vuetify.breakpoint.smAndDown') chevron_left
          span(v-if='!$vuetify.breakpoint.smAndDown') Предыдущая неделя
        v-btn(
          @click='nextPeriod'
          :disabled='!isRunning'
          :icon='$vuetify.breakpoint.smAndDown'
          color='default'
          class='mt-0'
          depressed small
        )
          span(v-if='!$vuetify.breakpoint.smAndDown') Следующая неделя
          v-icon(:right='!$vuetify.breakpoint.smAndDown') chevron_right
        v-btn(
          @click='$cal.fireMethod("today")'
          :disabled='!isRunning'
          v-if='$vuetify.breakpoint.mdAndDown'
          class='mt-0'
          color='accent'
          small flat
        ) Сегодня
  v-container(grid-list-xl fluid class='pa-0')
    v-layout(wrap)
      v-flex(xs12 sm4)
        s-schedule-complex-picker(
          :return-object='true'
          v-model='complex'
          label='Выберите комплекс'
        )
      v-flex(xs12 sm8 v-if='complex.id')
        s-schedule-object-picker(
          :label='objectsFilterLabel'
          :filter='x => x.complex_id == complex.id'
          v-model='objects'
          multiple
        )
      v-flex(v-show='isRunning' xs12)
        v-card(class='calendar')
          full-calendar(
            :config='config'
            @event-selected='onEventSelected'
            @day-click='onDayClick'
            ref='calendar'
          )
  time-modal(
    @change='onSave'
    :event='currEvent'
    :isLoading='isLoading'
    :duration='duration'
    v-model='modals.event'
  )
  v-dialog(scrollable max-width='320px' v-model='hint' persistent lazy)
    v-card
      v-card-title(class='title') Подсказка
      v-card-text
        div
          | Для копирования события, удерживайте нажатой
          | клавишу Alt на клавиатуре и переместите событие но новую дату
      v-card-actions
        v-spacer
        v-btn(@click='hint=false' flat) Ok

</template>

<script>
import Vue from 'vue'
import { FullCalendar } from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import { pick, omit } from 'lodash'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import TimeSlot from './TimeSlot'
import TimeModal from './TimeModal'
import emitter from '@/emitter'
import { extractDatetime, createDatetimeFromStart } from '@/utils'

let events = []

export default {
  components: {
    FullCalendar,
    TimeModal
  },

  data: function() {
    const vm = this
    return {
      hint: false,
      config: {
        locale: 'ru',
        height: 'auto',

        minTime: '07:00',
        maxTime: '21:00',

        slotDuration: '00:10:00',
        slotLabelFormat: 'HH:mm',
        columnHeaderFormat: 'ddd D MMM',

        header: false,
        selectable: false,
        allDaySlot: false,
        nowIndicator: true,
        eventDurationEditable: false,
        editable: true,
        eventOverlap() {
          return false
        },

        eventDragStart() {
          vm.$fakeEvent = this.cloneNode(true)
          this.parentNode.insertBefore(vm.$fakeEvent, this)
        },

        eventDrop(event, delta, revert) {
          // Если был зажать alt, делаем копию события
          if (vm.altKeyPressed) {
            const newEvent = omit(vm.pickEvent(event), 'id')
            vm.currEvent = newEvent
            vm.modals.event = true
          } else {
            vm.hint = true
          }
          // Удаляем копию, если она была
          if (vm.$fakeEvent) {
            vm.$fakeEvent.remove()
          }
          // Вернем ориганальное событие на место
          // откуда потянули
          revert()
        },

        eventRender(event, el) {
          events.push(
            new Vue({
              el: el.find('.fc-content').get(0),
              render(h) {
                return h(TimeSlot, {
                  props: { event, emitter }
                })
              }
            })
          )
        }
      },
      modals: {
        event: false
      },
      view: {},
      objects: [],
      complex: {},
      ctime: null,
      currEvent: {},
      duration: 30,
      isRunning: false
    }
  },

  mounted() {
    this.$cal.fireMethod('addEventSource', this.eventsSource)
    this.invalidateCalView()

    if (this.unlisten) {
      this.unlisten()
    }

    this.unlisten = this.listen()
  },

  beforeDestroy() {
    this.unlisten()

    events.forEach(e => e.$destroy())
    events = []

    this.$cal.fireMethod('destroy')
  },

  methods: {
    listen() {
      emitter.$on('schedule.update', this.onScheduleUpdate)
      emitter.$on('schedule.event.remove', this.onScheduleEventRemove)
      window.addEventListener('keyup', this.onKeyUp)
      window.addEventListener('keydown', this.onKeyDown)

      return () => {
        emitter.$off('schedule.update', this.onScheduleUpdate)
        emitter.$off('schedule.event.remove', this.onScheduleEventRemove)
        window.removeEventListener('keyup', this.onKeyUp)
        window.removeEventListener('keydown', this.onKeyDown)
      }
    },

    onKeyUp() {
      this.altKeyPressed = false
    },

    onKeyDown(ev) {
      if (ev.altKey) {
        this.altKeyPressed = true
      }
    },

    prevPeriod() {
      this.$cal.fireMethod('prev')
      this.updateView()
    },

    nextPeriod() {
      this.$cal.fireMethod('next')
      this.updateView()
    },

    updateView() {
      this.view = { ...this.$cal.fireMethod('getView') }
    },

    removeEvent(id) {
      return this.$cal.fireMethod('removeEvents', e => e.id === id)
    },

    refreshEvents() {
      this.$cal.fireMethod('refetchEvents')
    },

    invalidateCalView() {
      let view = 'agendaWeek'

      if (this.$vuetify.breakpoint.smAndDown) {
        view = 'agendaDay'
      }

      this.$cal.fireMethod('changeView', view)
      this.updateView()
    },

    /**
     * Возвращает только нужные поля для сохранения события
     * @param  {Object} event
     * @return {Object}
     */
    pickEvent(event) {
      return pick(event, [
        'allow',
        'complex_id',
        'end',
        'busy',
        'id',
        'objects',
        'start',
        'title'
      ])
    },

    async onSave(event) {
      if (this.isLoading) return

      let picked = this.pickEvent(event)

      // Если кто-то записан, просто
      // закроем даилоговое окно
      // if (picked.busy) {
      //   this.modals.event = false
      //   return
      // }

      Object.assign(picked, extractDatetime(event))

      try {
        if (picked.id) {
          if(picked.busy) {
            await this.update({
              id: picked.id,
              data: {
                allow:  picked.allow,
                complex_id: picked.complex_id
              }
            })
          } else {
          await this.update({
            id: picked.id,
            data: picked
          })
          }

        } else {
          await this.create({ data: picked })
        }
        this.modals.event = false
        this.currEvent = {}
      } catch (e) {
        this.$root.showSnack('Ошибка создания расписания')
      }
    },

    async onEventSelected(event) {
      this.currEvent = this.pickEvent(event)
      this.modals.event = true
    },

    isDoubleClicked() {
      let p = this.ctime == null ? new Date().getTime() - 1000000 : this.ctime
      return (this.ctime = new Date().getTime()) - p <= 500
    },

    onDayClick(startDate) {
      if (this.isDoubleClicked()) {
        let { start, end } = createDatetimeFromStart(startDate, this.duration)

        this.currEvent = {
          complex_id: this.complex.id,
          busy: 0,
          start,
          end
        }

        this.modals.event = true
      }
    },

    onScheduleUpdate({ complex_id }) {
      if (complex_id === this.complex.id) {
        this.refreshEvents()
      }
    },

    async onScheduleEventRemove(id) {
      if (!this.isLoading && (await this.$confirm('Удалить расписание?'))) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления расписания')
        }
      }
    },

    onTodayClick() {
      this.$cal.fireMethod('today')
      this.updateView()
    },

    ...mapMutations('app', ['incRequestsCount', 'decRequestsCount']),
    ...mapActions('schedule/schedule-create', ['create', 'update', 'destroy'])
  },

  computed: {
    $cal() {
      return this.$refs.calendar
    },

    title() {
      return this.view.title
    },

    objectsFilterLabel() {
      let count = this.objects.length
      let { declofnum } = this.$options.filters
      let postfix = declofnum(count, ['объекту', 'объектам', 'объектам'])

      return this.objects.length
        ? `Включен фильтр по ${postfix}`
        : `Отображаются  все объекты кoмплекса`
    },

    eventsSource() {
      let vm = this
      return {
        cache: true,
        timeout: 20000,
        url: `${vm.$config.baseURL}/manager/schedules`,

        data: () => ({
          objects: vm.objects,
          complex_id: vm.complex.id
        }),

        beforeSend(request) {
          request.setRequestHeader('Authorization', `Bearer ${vm.token}`)
          vm.incRequestsCount()
        },

        success({ state, data }) {
          vm.decRequestsCount()

          if (state) {
            return Object.values(data).map(e => ({
              ...e,
              textColor: '#313131',
              backgroundColor:
                e.busy >= e.allow
                  ? '#fce4ec'
                  : e.busy >= 1
                  ? '#ffe8ca'
                  : '#e8f5e9',
              objects: e.objects.map(o => o.object_id),
              allow: e.allow ? e.allow : 0,
              busy: e.busy ? e.busy : 0
            }))
          }
        },

        error() {
          vm.$root.showSnack('Ошибка загрузки расписания')
          vm.decRequestsCount()
        }
      }
    },

    ...mapState('auth', ['token']),
    ...mapGetters('schedule/schedule-create', ['isLoading'])
  },

  watch: {
    'complex.id'(val) {
      if (val && !this.isRunning) {
        this.isRunning = true
        this.$nextTick(() => {
          this.$cal.fireMethod('render')
          this.invalidateCalView()
        })
      }

      this.objects = []
      this.refreshEvents()
    },
    /**
     * Отслеживает изменения вьюпорта
     * на мобильных устройствах включаем режи ДЕНЬ
     * в противном случае - неделя
     * @type {Object}
     */
    '$vuetify.breakpoint': 'invalidateCalView',

    objects: 'refreshEvents'
  }
}
</script>

<style scoped>
.cal-toolbar {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
}
.calendar >>> th,
.calendar >>> thead,
.calendar >>> .fc-widget-header {
  border-top: 0;
}
.calendar >>> .fc-widget-content,
.calendar >>> .fc-widget-header,
.calendar >>> .fc-sun {
  border-right: 0;
}
.calendar >>> .fc-widget-header:first-child {
  border-left: 0;
}
.calendar >>> .fc-axis.fc-time,
.calendar >>> .fc-body > tr > .fc-widget-content {
  border-left: 0;
}
.calendar >>> .fc-widget-content {
  border-bottom: 0;
}
.calendar >>> .fc-axis.fc-time {
  font-size: 10px;
}
.calendar >>> .fc-widget-header span {
  padding: 12px 0;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
}
.calendar >>> .fc-event {
  padding: 3px;
  margin-top: 1px;
  border-radius: 0;
  border-color: white;
  color: #000 !important;
}
.calendar >>> .fc-today {
  background: none;
}
.calendar >>> .fc-day-header.fc-today {
  color: #eb8d8d;
}
.calendar >>> .fc-day-header span:first-letter {
  text-transform: uppercase;
}
.calendar >>> .fc-now-indicator {
  border-color: #eb8d8d;
}
.calendar >>> .fc-now-indicator-arrow {
  border: 0;
  width: 7px;
  height: 7px;
  left: 31px;
  margin-top: -3px;
  background: #eb8d8d;
  border-radius: 50%;
}
</style>
